import { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { CheckboxProps } from './types';
import s from './index.module.scss';

export const Checkbox = ({ indeterminate = false, ...props }: CheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  // indeterminate выставляется только из JS — атрибута у <input> нет
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <span className={classnames(s.checkbox, props.disabled && s.disabled)}>
      <input
        ref={inputRef}
        type="checkbox"
        className={s.checkbox__input}
        id={props.id || props.name}
        {...props}
      />
      <span className={s.checkbox__checkmark}>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 3L4.5 8.5L2 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </span>
  );
};
